import { LifeCycle } from './LifeCycle';
import { Segment } from './Segment';
import { SuppressTimeWindow } from './SuppressTimeWindow';

export enum OffsiteCampaignType {
  CartAbandonment = 'cartAbandonment',
  BrowseAbandonment = 'browseAbandonment',
  BulkRetargting = 'bulkRetargeting',
}

export interface OffsiteCampaign extends LifeCycle {
  siteId: string;
  id: string;
  name: string;
  type: OffsiteCampaignType;
  segments: Segment[];
  suppressTimeWindows?: SuppressTimeWindow;
  splitTestEndDate?: number;
  splitTestStartDate?: number;
  createdAt?: number;
  updatedAt?: number;
  updatedById?: string;
  lastEditingComment?: string;
  minimumBrowseTime?: number;
  version?: string;
  lookbackPeriod?: number;
}
